<template>
  <div class="container">
    <template>
      <div class="placement">
        <div class="placement__header">
          <div class="placement__header__preview">
            <h1 class="medium-title">{{titlePage}} Placement</h1>
          </div>
        </div>
        <div v-if="!isLoadingAll" class="placement__body">
          <!-- left Content -->
          <div class="placement__body__left">
            <div class="placement__body__left__form">
              <div class="placement__body__left__form__container">
                <div class="placement__body__left__form__container__item__route">
                  <adx-single-search-dropdown
                    :label="`Select Route`"
                    :optionsParam="routeOptions"
                    :errorLabel="`Route`"
                    :value.sync="model.routeDropdown"
                    :ref="vuelidateOptions.routeDropdown.ref"
                    :error.sync="vuelidateOptions.routeDropdown.error"
                    :validation="['NewNotEmpty']"
                  />
                </div>
              </div>
              <div class="placement__body__left__form__container">
                <h1 class="subhead">General Information</h1>
                <div class="placement__body__left__form__container__item">
                  <adx-input
                    :label="`Placement`"
                    :value.sync="model.placementInput"
                    :validation="['NewNotEmpty', 'NewMaxLength:50', 'NewMinLength:3', 'Alphanumeric']"
                    :ref="vuelidateOptions.placementInput.ref"
                    :error.sync="vuelidateOptions.placementInput.error"
                  />
                </div>
                <div class="placement__body__left__form__container__item">
                  <adx-textarea
                    :label="`Description`"
                    :value.sync="model.descriptionInput"
                    :validation="['NewNotEmpty', 'NewMaxLength:256', 'NewMinLength:1', 'Alphanumeric']"
                    :ref="vuelidateOptions.descriptionInput.ref"
                    :error.sync="vuelidateOptions.descriptionInput.error"
                  />
                </div>
                <div class="placement__body__left__form__container__items pricing">
                  <adx-input
                    :frontIcon="`rupiah`"
                    :label="`Price`"
                    :value.sync="model.priceInput"
                    :validation="['NewNotEmpty','NewMaxLength:10', 'NewMinLength:1']"
                    type="number"
                    :ref="vuelidateOptions.priceInput.ref"
                    :error.sync="vuelidateOptions.priceInput.error"
                  />
                  <adx-select-dropdown
                    :label="`Pricing Scheme`"
                    :options="schemeOptions"
                    :value.sync="model.schemeDropdown"
                    class="dropdown"
                    :validation="['NewNotEmpty']"
                    :ref="vuelidateOptions.schemeDropdown.ref"
                    :error.sync="vuelidateOptions.schemeDropdown.error"
                  />
                </div>
                <div class="placement__body__left__form__container__items quantity">
                  <adx-input
                    :label="`Quantity`"
                    :value.sync="model.quantityInput"
                    :validation="['NewNotEmpty', 'NewMaxLength:3', 'NewMinLength:1', 'MinValue:1']"
                    type="number"
                    :ref="vuelidateOptions.quantityInput.ref"
                    :error.sync="vuelidateOptions.quantityInput.error"
                  />
                  <adx-checkbox
                    :label="`Set As Unlimited`"
                    :value.sync="model.unlimited"
                    :valueLabel="`unlimited`"
                  />
                  <adx-checkbox
                    :label="`Out Of Stock`"
                    :value.sync="model.outOfStock"
                    :valueLabel="`outoftock`"
                  />
                </div>
              </div>
              <div class="placement__body__left__form__container">
                <h1 class="subhead">Route Details</h1>
                <div class="placement__body__left__form__container__items">
                  <adx-select-dropdown
                    :label="`Vehicle Type`"
                    :options="vehicleOptions"
                    :value.sync="model.vehicleTypeDropdown"
                    class="dropdown"
                    :validation="['NewNotEmpty']"
                    :ref="vuelidateOptions.vehicleTypeDropdown.ref"
                    :error.sync="vuelidateOptions.vehicleTypeDropdown.error"
                    :insertAddNew="`true`"
                    @addNew="toggleVehicleModal"
                  />
                  <adx-input
                    :label="`Number of Trip per Day`"
                    :value.sync="model.dailyTripInput"
                    :validation="['NewNotEmpty' , 'NewMaxLength:3', 'NewMinLength:1', 'MinValue:1']"
                    type="number"
                    :ref="vuelidateOptions.dailyTripInput.ref"
                    :error.sync="vuelidateOptions.dailyTripInput.error"
                  />
                </div>
                <div class="placement__body__left__form__container__items">
                  <adx-input
                    :label="`Seats`"
                    :value.sync="model.seatsInput"
                    :validation="['NewNotEmpty', 'NewMaxLength:3', 'NewMinLength:1', 'MinValue:1']"
                    type="number"
                    :ref="vuelidateOptions.seatsInput.ref"
                    :error.sync="vuelidateOptions.seatsInput.error"
                  />
                  <adx-input
                    :label="`Average passengers per day`"
                    :value.sync="model.trafficInput"
                    :validation="['NewNotEmpty', 'NewMaxLength:5', 'NewMinLength:1', 'MinValue:1']"
                    type="number"
                    :ref="vuelidateOptions.trafficInput.ref"
                    :error.sync="vuelidateOptions.trafficInput.error"
                  />
                </div>
              </div>
              <div class="placement__body__left__form__container">
                <h1 class="subhead">Purchase Restrictions</h1>
                <div class="placement__body__left__form__container__items period">
                  <adx-input
                    :label="`Minimum Period`"
                    :value.sync="model.periodInput"
                    :validation="['NewNotEmpty', 'NewMaxLength:2', 'NewMinLength:1', 'MinValue:1']"
                    type="number"
                    :ref="vuelidateOptions.periodInput.ref"
                    :error.sync="vuelidateOptions.periodInput.error"
                  />
                  <adx-select-dropdown
                    :options="timeOption"
                    :value.sync="model.month"
                    class="dropdown"
                  />
                </div>
                <div class="placement__body__left__form__container__items">
                  <adx-input
                    :label="`Minimum Quantity`"
                    :value.sync="model.minQuantityInput"
                    :validation="['NewNotEmpty', 'NewMaxLength:2', 'NewMinLength:1', 'MinValue:1']"
                    type="number"
                    :ref="vuelidateOptions.minQuantityInput.ref"
                    :error.sync="vuelidateOptions.minQuantityInput.error"
                  />
                </div>
                <div class="placement__body__left__form__container__items">
                  <adx-input
                    :label="`Lead Time`"
                    :value.sync="model.leadTimeInput"
                    :validation="['NewNotEmpty', 'NewMaxLength:3', 'NewMinLength:1', 'MinValue:7']"
                    type="number"
                    :ref="vuelidateOptions.leadTimeInput.ref"
                    :error.sync="vuelidateOptions.leadTimeInput.error"
                    :tooltip="`a time period of the earliest campaign can be executed relative from order date. For example, if the lead time is 6 days,
                it means that if an advertisers order today, the campaign will run 6 days from today`"
                    :icon="`day `"
                  />
                  <adx-input
                    :label="`Trail Time`"
                    :value.sync="model.trailTimeInput"
                    :validation="['NewNotEmpty', 'NewMaxLength:3', 'NewMinLength:1']"
                    type="number"
                    :ref="vuelidateOptions.trailTimeInput.ref"
                    :error.sync="vuelidateOptions.trailTimeInput.error"
                    :icon="`day `"
                    :tooltip="`a time period to clean up previous campaign. During this time, new campaign cannot be added. For example,
                billboard has trail time of 2 days. So when a campaign ends on 1st April, new advertisers can only come onboard by 3rd April (assuming no lead time).`"
                  />
                </div>
              </div>
              <div class="placement__body__left__form__container">
                <h1 class="subhead">Images</h1>
                <div
                  v-for="(image, index) in model.images"
                  :key="index"
                  class="placement__body__left__form__container__images__image"
                >
                  <div class="upload-wrapper">
                    <div class="top">
                      <div class="upload-button">
                        <input
                          type="file"
                          accept="image/*"
                          @change="getFile($event, image, index)"
                          :name="`fileUpload`+index"
                          :id="`fileUpload`+index"
                          style="display: none;"
                        />
                        <label :for="`fileUpload`+index" class="button-input">Add Image</label>
                      </div>
                      <div v-if="image.url" class="file-image">
                        <img :src="image.url" />
                      </div>
                      <div class="file-name">
                        <span class="image_name">
                          <label>{{image.name}}</label>
                          <i v-if="image.name" @click="cancelImage(index)" class="adx-ic_cancel"></i>
                        </span>
                        <div class="image_status" v-if="imageLoadings[index] != null">
                          <span v-if="imageLoadings[index]" class="is_loading">Loading...</span>
                          <span
                            v-if="!imageLoadings[index] && image.isSuccess"
                            class="is_success"
                          >Uploaded</span>
                          <span
                            v-if="!imageLoadings[index] && !image.isSuccess"
                            class="is_error"
                          >Error</span>
                        </div>
                      </div>
                    </div>
                    <div class="bottom">
                      <div>
                        <adx-checkbox
                          :label="`Set as featured image`"
                          :valueLabel.sync="image.isFeatured"
                          :value.sync="image.isFeatured"
                          :inputId="index"
                          @buttonClicked="buttonClicked(image)"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="icon-wrapper">
                    <i @click="deleteImages(model.images, index)" class="icon-deleted"></i>
                  </div>
                </div>
                <div class="line-wrapper">
                  <hr class="line" />
                </div>
                <div class="button">
                  <button @click="addImage(model.images)" class="new">Add new</button>
                </div>
              </div>
            </div>
          </div>
          <!-- Right Content -->
          <div class="placement__body__right">
            <div class="placement__body__right__status__container">
              <h1 class="subhead">Status ( Optional )</h1>
              <div>
                <adx-checkbox
                  :label="`Public`"
                  :value.sync="model.public"
                  :valueLabel="`unlimited`"
                />
              </div>
              <div>
                <adx-checkbox
                  :label="`Active`"
                  :value.sync="model.active"
                  :valueLabel="`unlimited`"
                />
              </div>
              <p v-if="!userInputted" class="error-message">Please select user owner.</p>
            </div>
            <div class="placement__body__right__status__container tags">
              <h1 class="subhead">Tags ( Optional )</h1>
              <div>
                <adx-input-tag
                  :limit="model.limit"
                  v-model="model.tagsText"
                  :ref="model.dataRef.tagsText"
                  :placeholder="model.placeholder"
                  :read-only="model.readOnly"
                  :validate="model.validate"
                  :add-tag-on-blur="model.addTagOnBlur"
                />
              </div>
              <p v-if="!userInputted" class="error-message">Please select user owner.</p>
            </div>
            <div class="button">
              <button class="btn-regular primary" @click="mapAndSave()">
                Save
                <adx-loading-2 v-if="saveLoading" />
              </button>
            </div>
          </div>
        </div>
        <!-- Modal -->
        <adx-modal
          v-if="isShowVehicleModal"
          @modal-close="toggleVehicleModal"
          title="Add New Vehicle"
          type="small"
        >
          <div slot="content" class="placement__modal">
            <div class="placement__modal__top">
              <adx-input
                :value.sync="vehicleModel.newVehicle"
                label="Vehicle"
                :validationMethod="'onChange'"
                :ref="vuelidateVehicleOptions.newVehicle.ref"
                :error.sync="vuelidateVehicleOptions.newVehicle.error"
                @keypress.enter.native="createVehicle"
              />
            </div>
            <div class="placement__modal__bottom">
              <button class="btn-regular secondary" @click="toggleVehicleModal">Cancel</button>
              <button class="btn-regular primary save" @click="createVehicle">
                Save
                <adx-loading-2 v-if="modalLoading" />
              </button>
            </div>
          </div>
        </adx-modal>
      </div>
    </template>
    <template v-if="isLoadingAll">
      <div class="container__loadingWrapper">
        <slot name="loading" />
        <adx-loading />
      </div>
    </template>
  </div>
</template>

<script>
import { AInput, ACheckbox, ATextArea, ASelectDropdown, ASingleSearchDropdown, ALoadingPrimary,
  ALoadingSecondary, ALoadingSecondaryWhite, AEmptySelection, AModal, ATooltip, AInputTag
} from "ui-kit-v1"
import { required, minLength, maxLength, alphaNum, alpha, requiredIf } from 'vuelidate/lib/validators'

import * as validationLib from "@/lib/validation/";
import triggerValidation from "@/lib/triggerValidation";

import { mapGetters } from "vuex";
import { parseErrorGql } from "@/lib/error";
import { restEdge } from "@/api/edgeUrls";
import api from "@/api";
const { helpers, validate } = validationLib
import { fromArrayKeys } from '@/lib/transformer'

export default {
  name: 'adx-addedit-bus-admin',
  components: {
    "adx-input": AInput,
    "adx-select-dropdown": ASelectDropdown,
    "adx-checkbox": ACheckbox,
    "adx-textarea": ATextArea,
    "adx-input-tag": AInputTag,
    "adx-single-search-dropdown": ASingleSearchDropdown,
    "adx-tooltip": ATooltip,
    "adx-modal": AModal,
    "adx-loading": ALoadingPrimary,
    "adx-loading-2": ALoadingSecondaryWhite
  },
  props: {

  },
  data() {
    const titlePage = this.$route.name == 'addnewbusplacement' ? 'Add' : 'Edit'

    return {
      busPlacement: null,
      count: 0,
      countBrand: 0,
      countRoute: 0,
      countVehicle: 0,
      eventRouteDone: false,
      eventBrandDone: false,
      eventVehicleDone: false,
      eventPlacementDone: false,
      initial: true,
      inputValue: undefined,
      isBrandLoading: true,
      isLoadingAll: false,
      isSaving: true,
      isShowBrandModal: false,
      isRouteLoading: true,
      isShowVehicleModal: false,
      isVehicleLoading: true,
      message: undefined,
      modalLoading: false,
      placementID: null,
      saveLoading: false,
      size: "small",
      type: null,
      userInputted: true,
      valid: undefined,
      imageLoadings: [],

      // Refactor
      placementId: null,
      model: {
        genericId: null,
        routeDropdown: null,

        placementInput: null,
        descriptionInput: null,
        priceInput: null,
        schemeDropdown: "month",
        quantityInput: null,
        unlimited: false,
        outOfStock: false,

        vehicleTypeDropdown: null,
        dailyTripInput: null,
        seatsInput: null,
        trafficInput: null,

        periodInput: null,
        month: "month",
        minQuantityInput: null,
        leadTimeInput: null,
        trailTimeInput: null,

        public: false,
        active: false,
        user: null,
        group: null,

        imageIds: [],
        imageFiles: [],
        images: [
          {
            name: null,
            image: null,
            isFeatured: null,
            url: null
          }
        ],
        limit: 100,
        tagsText: [],
        placeholder: "Separate tags with comma",
        readOnly: false,
        validate: "",
        addTagOnBlur: false,
        dataRef: {
          tagsText: "tagsText"
        },
      },
      vehicleModel: {
        newVehicle: null
      },
      vuelidateOptions: {
        routeDropdown: {
          field: 'route',
          error: null,
          ref: 'routeDropdown'
        },
        placementInput: {
          field: 'placement',
          error: null,
          ref: 'placementInput'
        },
        descriptionInput: {
          field: 'description',
          error: null,
          ref: 'descriptionInput'
        },
        priceInput: {
          field: 'price',
          error: null,
          ref: 'priceInput'
        },
        schemeDropdown: {
          field: 'pricing scheme',
          error: null,
          ref: 'schemeDropdown'
        },
        quantityInput: {
          field: 'quantity',
          error: null,
          ref: 'quantityInput'
        },
        vehicleTypeDropdown: {
          field: 'vehicle',
          error: null,
          ref: 'vehicleTypeDropdown'
        },
        dailyTripInput: {
          field: 'number of trip',
          error: null,
          ref: 'dailyTripInput'
        },
        seatsInput: {
          field: 'seats',
          error: null,
          ref: 'seatsInput'
        },
        trafficInput: {
          field: 'avarage passenger',
          error: null,
          ref: 'trafficInput'
        },
        periodInput: {
          field: 'period',
          error: null,
          ref: 'periodInput'
        },
        minQuantityInput: {
          field: 'min quantity',
          error: null,
          ref: 'minQuantityInput'
        },
        leadTimeInput: {
          field: 'lead time',
          error: null,
          ref: 'leadTimeInput'
        },
        trailTimeInput: {
          field: 'trail time',
          error: null,
          ref: 'trailTimeInput'
        }
      },
      vuelidateVehicleOptions: {
        newVehicle: {
          field: 'vehicle',
          error: null,
          ref: 'newVehicle'
        }
      },
      routeOptions: [],
      vehicleOptions: [],
      schemeOptions: [
        {
          id: 0,
          label: "Day",
          value: "day"
        },
        {
          id: 1,
          label: "Week",
          value: "week"
        },
        {
          id: 2,
          label: "Month",
          value: "month"
        }
      ],
      timeOption: [
        {
          id: 0,
          label: "Day",
          value: "day"
        },
        {
          id: 1,
          label: "Week",
          value: "week"
        },
        {
          id: 2,
          label: "Month",
          value: "month"
        },
        {
          id: 3,
          label: "Year",
          value: "year"
        }
      ],
      titlePage: titlePage
    }
  },
  validations: {
    model: {
      routeDropdown: { required },
      placementInput: { required },
      descriptionInput: { required, maxLength: maxLength(256) },
      priceInput: { required },
      schemeDropdown: { required },
      quantityInput: { required },
      vehicleTypeDropdown: { required },
      dailyTripInput: { required },
      seatsInput: { required },
      trafficInput: { required },
      periodInput: { required },
      minQuantityInput: { required },
      leadTimeInput: { required },
      trailTimeInput: { required }
    },
    vehicleModel: {
      newVehicle: { required, minLength: minLength(3), maxLength: maxLength(50) }
    },
  },
  computed: {

  },
  watch: {

  },
  beforeCreate() {

  },
  created() {
    if (this.$route.params.hasOwnProperty('id')) this.placementId = this.$route.params.id
  },
  beforeMount() {

  },
  mounted() {
    this.getOptions()
    if(this.placementId) this.getBusPlacement()
  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    // Load Data Edit
    async getBusPlacement() {
      this.isLoadingAll = true
      const response = await api.get(
        restEdge.getOneBusPlacement(this.$route.params.id),
        {
          needToken: true,
          useRestEdge: true
        }
      );

      if (response.status == 200) {
        this.busPlacement = response.data;
        this._mapData(this.busPlacement);
        this.isLoadingAll = false;
      } else {
        this.raiseError("Placement not found!");
        this.isLoadingAll = false;
      }
    },
    async _mapData(busPlacement) {
      let ids = [];
      let imgs = [];
      if (busPlacement.generic) {
        await busPlacement.contents.map(content => {
          let imgArray = content.content_url.split("/");
          let imgName = imgArray.pop();
          ids.push({ id: parseInt(content.id) });
          imgs.push({
            id: parseInt(content.id),
            name: imgName,
            image: content.content_url,
            url: content.content_url,
            isFeatured: content.is_featured
          });
        });
        this.model.imageIds = await ids;
        this.model.images = await imgs;
        this.model.dailyTripInput = await busPlacement.daily_trip;
        this.model.seatsInput = await busPlacement.seats;
        this.model.trafficInput = await busPlacement.traffic;
        this.model.placementInput = await busPlacement.generic.title;
        this.model.descriptionInput = await busPlacement.generic.description;
        this.model.quantityInput = await busPlacement.generic.quantity;
        this.model.minQuantityInput = await busPlacement.generic.minQuantity;
        this.model.priceInput = await busPlacement.generic.price;
        this.model.schemeDropdown = await busPlacement.generic.pricingPlan;
        this.model.periodInput = await parseInt(busPlacement.generic.minPeriod) || 0;
        this.model.month = await busPlacement.generic.minPeriodPlan;
        this.model.leadTimeInput = await busPlacement.generic.leadPreCampaign;
        this.model.trailTimeInput = await busPlacement.generic.leadPostCampaign;
        this.model.active = await busPlacement.generic.isActive;
        this.model.public = await busPlacement.generic.isPublic;
        this.model.unlimited = await busPlacement.generic.unlimited;
        this.model.outOfStock = await busPlacement.generic.outOfStock;
        this.model.tagsText = (await busPlacement.generic.tagList) || [];
        this.model.routeDropdown = await busPlacement.route ? busPlacement.route.id : null;
        this.model.vehicleTypeDropdown = await busPlacement.vehicle.id;
        this.model.genericId = await busPlacement.generic.id;
      } else {
        this.count = 0;
        this.getBusPlacement();
      }
    },
    // Get Base Data Options
    async _fetchDataOptions() {
      const { data, status } = await api.get(restEdge.formGeneric, {
        needToken: true,
        useRestEdge: true
      });

      if(status == 200) {
        return data
      } 
    },
    async getOptions() {
      const data = await this._fetchDataOptions()
      const { vehicles, routes } = fromArrayKeys(data)
      this.vehicleOptions = vehicles
      this.routeOptions = routes
    },

    // Save / Submit Form
    async mapAndSave() {
      const contentIds = this.model.images.map(image => {
        return {
          id: image.id,
          is_featured: image.isFeatured
        }
      })
      const isValid = await this._validateBeforeSave()
      if(!isValid){
        return
      }

      let response;

      if(this.placementId) {
        const body = {
          daily_trip: parseInt(this.model.dailyTripInput),
          seats: parseInt(this.model.seatsInput),
          traffic: parseInt(this.model.trafficInput),
          contents: contentIds,
          vehicle: this.model.vehicleTypeDropdown,
          route: this.model.routeDropdown,
          generic: {
            id: this.model.genericId,
            title: this.model.placementInput,
            description: this.model.descriptionInput,
            quantity: parseInt(this.model.quantityInput),
            isActive: this.model.active,
            isPublic: this.model.public,
            price: parseInt(this.model.priceInput),
            pricingPlan: this.model.schemeDropdown,
            minPeriod: this.model.periodInput,
            minPeriodPlan: this.model.month,
            minQuantity: parseInt(this.model.minQuantityInput),
            leadPreCampaign: parseInt(this.model.leadTimeInput),
            leadPostCampaign: parseInt(this.model.trailTimeInput),
            unlimited: this.model.unlimited,
            outOfStock: this.model.outOfStock,
            channelNameId: 1,
            brandId: null,
            owner: null
          }
        };
        
        response = await api.patch(
          restEdge.updatePlacement(this.$route.params.id),
          body,
          { needToken: true, useRestEdge: true }
        );
      } else {
        const body = {
          title: this.model.placementInput,
          description: this.model.descriptionInput,
          quantity: parseInt(this.model.quantityInput),
          isActive: this.model.active,
          isPublic: this.model.public,
          price: parseInt(this.model.priceInput),
          pricingPlan: this.model.schemeDropdown,
          minQuantity: parseInt(this.model.minQuantityInput),
          minPeriod: parseInt(this.model.periodInput),
          minPeriodPlan: this.model.month,
          leadPreCampaign: parseInt(this.model.leadTimeInput),
          leadPostCampaign: parseInt(this.model.trailTimeInput),
          unlimited: this.model.unlimited,
          outOfStock: this.model.outOfStock,
          channelNameId: 1,
          route: this.model.routeDropdown,
          contents: contentIds,
          dailyTrip: parseInt(this.model.dailyTripInput),
          seats: parseInt(this.model.seatsInput),
          traffic: parseInt(this.model.trafficInput),
          impression: this.model.estimationImpression,
          distance: this.model.tripDistance,
          vehicle: this.model.vehicleTypeDropdown,
          brandId: null
        };
        response = await api.post(restEdge.createGeneric, body, {
          needToken: true,
          useRestEdge: true
        });
      }

      if(response.status == 200) {
        this.$notify({
          group: "saved",
          title: "Success",
          text: `Data successfully saved!`,
          type: "success"
        });
        this.$router.push({ name: "busplacement", query: { from: "add" } });
      } else {
        this.$notify({
            group: "saved",
            title: "Error",
            text: `Data failed to save`,
            type: "danger"
          });
      }
    },
    async _validateBeforeSave() {
      this.$v.$touch()

      if (this.$v.model.$invalid) {
        const { key, message, element, collection } = helpers.vuelidateValidationHelper(this.$v.model, this.vuelidateOptions, this.$refs)
        if (collection) {
          this.vuelidateOptions[key].error[collection.index][collection.collectionKey] = message
        } else {
          this.vuelidateOptions[key].error = message
        }
        if (element) {
          this.$nextTick(function() {
            element.scrollIntoView()
          })
        }
        return false
      } else {
        return true
      }
    },

    // Create Vehicle
    toggleVehicleModal() {
      this.isShowVehicleModal = !this.isShowVehicleModal;
    },
    async createVehicle(event, button) {
      this.$v.$touch()

      if (this.$v.vehicleModel.$invalid) {
        const { key, message, element, collection } = helpers.vuelidateValidationHelper(this.$v.vehicleModel, this.vuelidateVehicleOptions, this.$refs)
        this.vuelidateVehicleOptions[key].error = message
        if (element) {
          this.$nextTick(function() {
            element.scrollIntoView()
          })
        }
        return
      }

      let body = {
        title: this.vehicleModel.newVehicle
      };
      const response = await api.post(restEdge.createVehicle, body, {
        needToken: true,
        useRestEdge: true
      });
      if (response.status == 200) {
        this.vehicleOptions.push({id: response.data.id, title: response.data.title, label: response.data.title, value: response.data.id})
        this.toggleVehicleModal()

      }
    },

    // Images methods ( validation, add, upload, etc)
    addImage(images) {
      images.push({
        id: null,
        name: null,
        image: null,
        isFeatured: null,
        url: null
      });
      this.imageLoadings.push(null);
    },
    getFile(event, image, index) {
      let input = event.target;
      if (input.files && input.files[0]) {
        let reader = new FileReader();
        let validated_data = this._validateFile(input.files[0]);
        if (!validated_data.is_valid) {
          // this.error["avatar"] = validated_data.message;
          this.$notify({
            group: "saved",
            title: "Error",
            text: validated_data.message,
            type: "danger"
          });
        } else {
          reader.onload = e => {
            image.url = e.target.result;
          };
          reader.readAsDataURL(input.files[0]);
          image.name = input.files[0].name;
          image.image = input.files[0];
          this._saveImage(input.files[0], image, index);
        }
      }
    },
    _validateFile(file) {
      let maxSize = 300000; // 300 kb
      let data = { is_valid: true };
      if (/image/.test(file.type)) {
        let image_ext_patt = new RegExp(/.jpg|.jpeg|.png/);
        if (!image_ext_patt.test(file.name.toLowerCase())) {
          data.is_valid = false;
          data.message = "Unsupported file type";
          return data;
        }
      } else {
        data.is_valid = false;
        data.message = "Unsupported file type";
        return data;
      }
      if (file.size > maxSize) {
        data.is_valid = false;
        data.message = `File too large.`;
        return data;
      }
      const filename = file.name.split(".")[0];
      if (filename.length > 100) {
        data.is_valid = false;
        data.message = "File name is too long. Maximum size 100 character";
        return data;
      }

      if (filename.includes("/")) {
        data.is_valid = false;
        data.message = "File name has forbidden character";
        return data;
      }
      return data;
    },
    async _saveImage(fileData, image, index) {
      image.loading = true;
      this.$set(this.imageLoadings, index, true);

      let formData = new FormData();
      formData.append("file", fileData);
      formData.append("name", fileData.name);
      const response = await api.post(restEdge.uploadFile, formData, {
        needToken: true,
        useRestEdge: true,
        headers: { "Content-Type": "multipart/form-data" }
      });

      await this.$nextTick();
      this.$set(this.imageLoadings, index, false);

      if (response.status == 200) {
        image.isSuccess = true;
        image.id = parseInt(response.data.id);
        this.model.imageIds.push({ id: parseInt(response.data.id) });
      } else {
        image.isSuccess = false;
      }
    },

    // Misc
    getId(options, value) {
      let id = null;
      for (let it = 0; it < options.length; it++) {
        if (options[it].value === value) {
          id = options[it].id;
        }
      }
      return id;
    },
    async buttonClicked(image) {
      await this.model.images.map(async x => {
        if (x.id !== image.id) x.isFeatured = await false;
      });
    },
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>